/**
 * @module FE-CU15_戸締り確認画面_エリアコンポーネント
 */
import ListPanel from '@/components/listPanel/ListPanel.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

export default {
  name: 'LockConfirmationArea',
  components: {
    ListPanel,
    PCFooter,
  },
  props: {
    panelTitle: {
      type: Object,
      required: false,
    },
    displayAreaList: {
      type: Array,
      required: false,
    },
    areaType: {
      type: Number,
      default: 1,
      required: false,
    },
    securityAreaList: {
      type: Array,
      required: false,
    },
    notificationImage: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      typeLock: 1, //いずれグローバルな定数化
      typeAlert: 2,
    };
  },
};
